"use strict";

exports.__esModule = true;
exports.useTicketDetailsController = useTicketDetailsController;
var _react = _interopRequireWildcard(require("react"));
var _TicketingContext = require("../TicketingContext");
var _RestAPI = require("../../API/RestAPI");
var _System = require("../../../System");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function useTicketDetailsController(props) {
  var _React$useContext = _react["default"].useContext(_TicketingContext.TicketingContext),
    getTicketDetails = _React$useContext.getTicketDetails,
    fetchTicketTypes = _React$useContext.fetchTicketTypes,
    updateTicketDetails = _React$useContext.updateTicketDetails,
    createTicketComment = _React$useContext.createTicketComment,
    editTicketComment = _React$useContext.editTicketComment,
    deleteTicketComment = _React$useContext.deleteTicketComment,
    assignTicketToUser = _React$useContext.assignTicketToUser,
    assignTicket = _React$useContext.assignTicket;
  var _useState = (0, _react.useState)(false),
    updateTicket = _useState[0],
    setUpdateTicket = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    editMode = _useState2[0],
    setEditMode = _useState2[1];
  var ticketId = props.ticketId,
    onClose = props.onClose,
    refreshData = props.refreshData,
    history = props.history,
    isFullScreen = props.isFullScreen;
  function refreshTicketData() {
    if (refreshData) {
      refreshData();
    } else {
      setUpdateTicket(!updateTicket);
    }
  }
  function handleUpdateTicket(_x) {
    return _handleUpdateTicket.apply(this, arguments);
  }
  function _handleUpdateTicket() {
    _handleUpdateTicket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(updateQuery) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return updateTicketDetails(ticketId, updateQuery);
          case 1:
            refreshTicketData();
            setEditMode(false);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _handleUpdateTicket.apply(this, arguments);
  }
  function handleAssigneeClick() {
    return _handleAssigneeClick.apply(this, arguments);
  }
  function _handleAssigneeClick() {
    _handleAssigneeClick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return assignTicket(ticketId);
          case 1:
            refreshTicketData();
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _handleAssigneeClick.apply(this, arguments);
  }
  function handleAssignToUser(_x2) {
    return _handleAssignToUser.apply(this, arguments);
  }
  function _handleAssignToUser() {
    _handleAssignToUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(userId) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return assignTicketToUser(ticketId, userId);
          case 1:
            refreshTicketData();
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _handleAssignToUser.apply(this, arguments);
  }
  function handleCreateComment(_x3) {
    return _handleCreateComment.apply(this, arguments);
  }
  function _handleCreateComment() {
    _handleCreateComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(comment) {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _context4.n = 1;
            return createTicketComment(ticketId, comment);
          case 1:
            setUpdateTicket(!updateTicket);
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _handleCreateComment.apply(this, arguments);
  }
  function handleEditTicketComment(_x4, _x5) {
    return _handleEditTicketComment.apply(this, arguments);
  }
  function _handleEditTicketComment() {
    _handleEditTicketComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(commentId, comment) {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return editTicketComment(ticketId, commentId, comment);
          case 1:
            setUpdateTicket(!updateTicket);
          case 2:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return _handleEditTicketComment.apply(this, arguments);
  }
  function handleDeleteTicketComment(_x6) {
    return _handleDeleteTicketComment.apply(this, arguments);
  }
  function _handleDeleteTicketComment() {
    _handleDeleteTicketComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(commentId) {
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            _context6.n = 1;
            return deleteTicketComment(ticketId, commentId);
          case 1:
            setUpdateTicket(!updateTicket);
          case 2:
            return _context6.a(2);
        }
      }, _callee6);
    }));
    return _handleDeleteTicketComment.apply(this, arguments);
  }
  function handleClose() {
    if (isFullScreen) {
      history.push((0, _System.getScreenURL)("TicketList"));
    } else if (onClose) {
      onClose();
    } else {
      console.error("onClose function is not provided");
    }
  }
  var ticketRequest = _react["default"].useCallback(function getDetailsCallback() {
    return getTicketDetails(ticketId);
  }, [ticketId, updateTicket]);
  // This is fetched every time ticketRequest is updated
  var ticketTypeRequest = _react["default"].useCallback(function () {
    return fetchTicketTypes();
  }, []);
  var requests = _react["default"].useMemo(function requestList() {
    return [ticketRequest, ticketTypeRequest];
  }, [ticketRequest, ticketTypeRequest]);
  var _useRequestPromiseLoa = (0, _RestAPI.useRequestPromiseLoader)({
      requests: requests
    }),
    isLoading = _useRequestPromiseLoa.loading,
    data = _useRequestPromiseLoa.data,
    error = _useRequestPromiseLoa.error;
  return {
    isLoading: isLoading,
    data: data,
    error: error,
    handleUpdateTicket: handleUpdateTicket,
    handleAssigneeClick: handleAssigneeClick,
    handleCreateComment: handleCreateComment,
    handleEditTicketComment: handleEditTicketComment,
    handleDeleteTicketComment: handleDeleteTicketComment,
    handleClose: handleClose,
    handleAssignToUser: handleAssignToUser,
    refreshTicketData: refreshTicketData,
    editMode: editMode,
    setEditMode: setEditMode
  };
}